import {
	lazy,
} from 'react'

export const NotFoundPageAsync = lazy(async() => {
	return import('./not-found.page')
})
